import { render, staticRenderFns } from "./MVCountDown.vue?vue&type=template&id=2e6fc2b1&scoped=true&"
import script from "./MVCountDown.vue?vue&type=script&lang=js&"
export * from "./MVCountDown.vue?vue&type=script&lang=js&"
import style0 from "./MVCountDown.vue?vue&type=style&index=0&id=2e6fc2b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6fc2b1",
  null
  
)

export default component.exports